import $ from 'jquery';

import JsonApi from "./jsonApi";
import store from "../store";
import {loaderEnable, loaderDisable} from "../bvcomponents/ui/loaderView";
import * as types from "../actions/actionTypes";
import Misc from "../misc/misc";
import Config, {IS_LIXIL_UI, IS_OFFLINE_MODE, POST_MESSAGES} from "../config";
import Analytics from '../analytics';
import {saveQuote} from "./server-api";
import {
  renderErrorPopup,
  renderAccountNotActivatedErrorPopup,
  renderConfirmPopup,
  renderMessagePopup
} from "./api-popups";
import {ConfirmPopupTypes, QuoteRequestType, UserAction, UserPopupTypes} from "../bvcomponents/visComponents/constants";
import {showCheckoutLayout, toggleUserPopup} from "../actions/actionFunctions";
import {showQuoteSavedNotification} from "../bvcomponents/ui/successNotification";
import ActionTypes from "../misc/actionTypes";
import {setAlreadyRegisteredUserInfo, setEmployeesList} from "../actions/userFunctions";
import {restorePaymentInfo} from "../actions/paymentFunctions";
import {addGACookie} from "../misc/backendFunctions";
import {LOOK_OVERLAYS} from "../bvcomponents/look/core/constants";
import {setLookOverlayOpened} from "../actions/lookFunctions";
import {setLookAiImageOpened} from "../bvcomponents/ai/aiActions";
import {reportNonFatalError} from "../misc/errorReporting/errorReporter";
import {isHttpAccessError, isNetworkConnectivityError} from "../misc/errorReporting/browserInstrumentation";


export const scheduleCustomer = (data) => {
  loaderEnable("loader.scheduleCustomerText", "loader.scheduleCustomerTitle");
  const state = store.getState();
  const {serverState} = state;
  let {time} = data;
  let am = true;
  if (time > 1200) {
    am = false;
    time -= 1200;
  }
  const scheduleData = {
    scheduleEntryData: {
      date: data.date,
      time: `${time / 100}:00`,
      am: am,
      duration: 60,
      alert: 30,
      appointmentType: 'Quote'
    },
    jobId: serverState.jobId,
    jobIdType: 'JobQuote'
  };

  JsonApi.scheduleCustomer(scheduleData)
    .then(response => {
      console.log('Schedule answer', response);
      loaderDisable();
      store.dispatch({
        type: types.SHOW_SCHEDULER,
        payload: {show: false}
      })
    });
};

export const setUserLoginResponse = (responseData,
                                     fromConfirmationDialog = false,
                                     quoteRequestType,
                                     yesNoConsultationRequest,
                                     showSchedule,
                                     checkout,
                                     userPopupType) => {
  console.log(responseData);
  // const saveQuoteAfterLogin = state.userState.saveQuoteAfterLogin;
  // if (!saveQuoteAfterLogin) {
  //     loaderDisable();
  // }
  const state = store.getState();

  if (responseData.error) {
    Analytics.sendClickEvent("user-login-failure");
    if (state.fabricatorState.isNhance) {
      Analytics.sendParentPostMessage(POST_MESSAGES.userLoginFalse);
    }
    const {error} = responseData;
    loaderDisable();
    if (responseData.error.indexOf('has not been activated yet') !== -1) {
      const userInfo = store.getState().userState.userInfo;
      renderAccountNotActivatedErrorPopup(error, userInfo.email);
    } else {
      renderErrorPopup(responseData.error);
    }
    if (fromConfirmationDialog) {
      store.dispatch(toggleUserPopup({
        userPopupOpened: true,
        userPopupType
      }));
    }
    return false;
  }

  const fabricatorSettings = state.fabricatorState.settings;

  // const docuSignObj = fabricatorSettings.docuSignAuth ? JSON.parse(fabricatorSettings.docuSignAuth) : null;
  // Config.setUserInfo(responseData);
  Analytics.sendClickEvent("user-login-success");
  Analytics.setUserId(responseData.encodedUserId);
  Analytics.setExistingMixPanelPerson(responseData.email);
  if (state.fabricatorState.isNhance) {
    Analytics.sendParentPostMessage(POST_MESSAGES.userLoginTrue);
  }
  const updatedUserInfo = Misc.parseUserResponse(responseData);
  // const isPhoneNumberValidated = responseData.isPhoneNumberValidated || !responseData.pendingPhoneVerification;
  const isPhoneNumberValidated = !fabricatorSettings.twoFA || responseData.isPhoneNumberValidated || !responseData.pendingPhoneVerification;

  store.dispatch({
    type: types.TOGGLE_USER_POPUP,
    payload: {
      userPopupOpened: false,
      userIsLoggedIn: true,
      isPhoneNumberValidated,
      userInfo: updatedUserInfo,
      // email: responseData.email,
      encodedUserId: responseData.encodedUserId,
      // phoneNumber: responseData.phoneNumber,
      // values: responseData.values
    }
  });

  if (responseData.billingAddress || responseData.shippingAddress) { // update user state
    store.dispatch(restorePaymentInfo(Misc.parseShippingAndBillingResponse(responseData)));
  }

  if (IS_LIXIL_UI) { // we don't go below, as we already have save in the lixil logic
    return {...responseData, isPhoneNumberValidated: isPhoneNumberValidated || !fabricatorSettings.twoFA}
  }

  if (fabricatorSettings.twoFA && responseData.pendingPhoneVerification) {
    store.dispatch({
      type: types.TOGGLE_USER_POPUP,
      payload: {userPopupOpened: true}
    });
  } else {
    saveQuote({
      submit: true,
      quoteRequestType,
      yesNoConsultationRequest,
      fromCheckOutPage: window.location.href.includes('shoppingcart'),
      showContractSignOnError: true,
      showReceipt: false
    })
      .then(() => {
        $(document).trigger(ActionTypes.USER_IS_LOGGED_IN); // click on the active item it the navigation
        if (showSchedule) {
          loaderDisable();
          if (fabricatorSettings.enableCalendarForScheduling) {
            store.dispatch({
              type: types.SHOW_SCHEDULER,
              payload: {show: true}
            })
          } else {
            renderMessagePopup('userPopup.messageBox.appointmentRequested');
          }
        } else {
          loaderDisable();
          if (userPopupType === UserPopupTypes.AIDesign) { // do not show save success notification
            store.dispatch(setLookOverlayOpened(LOOK_OVERLAYS.aiPanel));
            store.dispatch(setLookAiImageOpened(true));
            return
          }
          showQuoteSavedNotification(
            quoteRequestType === QuoteRequestType.RequestQuote
              ? "successNotification.titleQuoteRequested"
              : "successNotification.titleQuoteSaved"
          );
          // console.log('DS - login', fabricatorSettings.showPricing, docuSignObj);
          // if (fabricatorSettings.showPricing && docuSignObj && docuSignObj.isEnabled)
          //     store.dispatch(showDocuSign(true));
          if (checkout && fabricatorSettings.checkout) {
            showCheckoutLayout(fabricatorSettings);
          }
        }
      })
      .catch((error) => {
        console.error('saveQuote error:', error);
        loaderDisable();
      })
  }

  if (showSchedule) {
    if (fabricatorSettings.enableCalendarForScheduling) {
      store.dispatch({
        type: types.SHOW_SCHEDULER,
        payload: {show: true}
      })
    } else {
      renderMessagePopup('userPopup.messageBox.appointmentRequested');
    }
  }
}

export const userLogin = ({
                            showConfirmationPopup = false,
                            showSchedule = false,
                            quoteRequestType = QuoteRequestType.RegularDesign,
                            yesNoConsultationRequest = false,
                            userPopupType,
                            fromConfirmationDialog = false,
                            checkout = false
                          } = {}) => {
  if (showConfirmationPopup) {
    store.dispatch({
      type: types.TOGGLE_USER_POPUP,
      payload: {
        userPopupOpened: false
      }
    });
    renderConfirmPopup(ConfirmPopupTypes.ConsultationRequest, {
      userAction: UserAction.Login,
      userPopupType
    });
    return;
  }
  const state = store.getState();
  const userInfo = state.userState.userInfo;
  const showAdditionalFields = state.userState.showAdditionalFields;
  if (!IS_LIXIL_UI) {
    loaderEnable();
  }
  let data = {
    email: userInfo.email,
    password: userInfo.password,
    employeeId: showAdditionalFields ? +userInfo.employeeId : 0,
    fabricatorId: document.kvConfig.userId,
  }
  data = addGACookie(data);

  return JsonApi.userLogin(data)
    .then((response) => {
      return setUserLoginResponse(
        response.data,
        fromConfirmationDialog,
        quoteRequestType,
        yesNoConsultationRequest,
        showSchedule,
        checkout,
        userPopupType
      )
    })
    .catch((error) => {
      console.log('User login error:', error);
      loaderDisable();
      renderErrorPopup("Login "+new Error(error.message || error));
      if (state.fabricatorState.isNhance) {
        Analytics.sendParentPostMessage(POST_MESSAGES.userLoginFalse);
      }
    });
};

const callUserRegisterErrorPopup = (responseData,
                                    userPopupType,
                                    fromConfirmationDialog,
                                    assignQuote = false,
                                    withCheckoutLogic = false,
                                    noInternetCallBack = null,
                                    afterContractSignCallback = null,
                                    executeAfterRegisterIfUserExist = null) => {
  Analytics.sendClickEvent("user-register-failure");

  if (responseData.isEmailTaken && responseData.errorUserMatch) {
    store.dispatch(setAlreadyRegisteredUserInfo({...responseData.errorUserMatch, assignQuote, withCheckoutLogic, userId: responseData.userId}));
    renderConfirmPopup(ConfirmPopupTypes.AssignQuoteOnExistingUser, {applyFunction: executeAfterRegisterIfUserExist}, true);
    loaderDisable();
    return
  }

  renderErrorPopup(responseData.error, "", noInternetCallBack, withCheckoutLogic, null, afterContractSignCallback);

  if (fromConfirmationDialog) {
    store.dispatch(toggleUserPopup({
      userPopupOpened: true,
      userPopupType
    }));
  }

}

const isValidUserRegisterResponse = (response) => !!response
  && !!response.data
  && typeof response.data === 'object'
  && !Array.isArray(response.data);

/**
 * Message passed to renderErrorPopup for a rejected RegisterClient request.
 * Network / 401 / 403 errors are passed as the error object so renderErrorPopup
 * shows its "no internet" (with retry + contract sign) or access-error popups.
 */
const getUserRegisterRequestErrorMessage = (error) => {
  if (isNetworkConnectivityError(error) || isHttpAccessError(error)) {
    return error;
  }
  const responseData = error && error.response && error.response.data;
  if (responseData && typeof responseData === 'object' && typeof responseData.error === 'string' && responseData.error) {
    return responseData.error;
  }
  const status = error && error.response && error.response.status;
  return "Registration failed" + (status ? ` (server error ${status})` : "") + ". Please try again.";
};

export const userRegister = async ({
                               showConfirmationPopup = false,
                               showSchedule = false,
                               quoteRequestType = QuoteRequestType.RegularDesign,
                               yesNoConsultationRequest = false,
                               userPopupType,
                               fromConfirmationDialog = false,
                               // checkout = false,
                               assignQuote = false,
                               withCheckoutLogic = false,
                               noInternetCallBack = null,
                               afterContractSignCallback = null,
                               executeAfterRegisterIfUserExist = null,
                             } = {}) => {
  //console.log('register', quoteRequestType);
  if (showConfirmationPopup) {
    store.dispatch({
      type: types.TOGGLE_USER_POPUP,
      payload: {
        userPopupOpened: false
      }
    });
    renderConfirmPopup(ConfirmPopupTypes.ConsultationRequest, {
      userAction: UserAction.Register,
      userPopupType,
      quoteRequestType
    });
    return;
  }

  const {userState, serverState, fabricatorState} = store.getState();
  const userInfo = userState.userInfo;
  // userInfo.phone = userInfo.phoneNumber;
  // if (!store.getState().userState.showAdditionalFields) {
  //   userInfo.employeeId = ""
  // }
  if (!IS_LIXIL_UI) {
    loaderEnable();
  }
  let data = {
    email: userInfo.email,
    firstName: userInfo.firstName,
    phone: `+${userInfo.country.dialCode} ${userInfo.phoneNumber}`,
    agreedToTerms: userInfo.agreedToTerms,
    subscribeToNewsletter: userInfo.subscribeToNewsletter,
    isNew: true,
    postal: userInfo.postal,
    salesPersonFullName: userInfo.salesPersonFullName,
    salesPersonEmail: userInfo.salesPersonEmail,
    employeeId: +userInfo.employeeId,
    fabricatorId: Config.kvConfig.userId || 61986,
    quoteRequestType,
    yesNoConsultationRequest,
    lastName: userInfo.lastName,
    address1: userInfo.address1,
    address2: userInfo.address2,
    city: userInfo.city,
    state: userInfo.state,
    country: userInfo.country.iso2,
    preferredCommunicationMethod: userInfo.preferredCommunicationMethod,
    howDidYouHearAboutUs: userInfo.howDidYouHearAboutUs,
    phone2: userInfo.phone2,
    language: serverState.language,
    subId: document.subId && document.subId.toString ? document.subId.toString() : null,
  };

  data = addGACookie(data);

  if (assignQuote) {
    ["lastName", "phone2", "address1", "address2", "city", "preferredCommunicationMethod", "howDidYouHearAboutUs"]
      .forEach((property) => {
        data[property] = userInfo[property] // new fields added in new assign quote popup
      })
  }

  let registerResponse;
  let registerRequestError = null;

  try {
    registerResponse = await JsonApi.userRegister(data);
  } catch (error) {
    if (error && (error.message === "Network Error") && IS_OFFLINE_MODE) {
      // offline mode: keep the existing "no internet" popup with retry / contract-sign options
      registerResponse = {data: {error: "Network Error"}}
    } else {
      registerRequestError = error || new Error("RegisterClient request failed");
    }
  }

  if (!IS_LIXIL_UI) {
    loaderDisable();
  }

  const callErrorPopup = (responseData) => callUserRegisterErrorPopup(responseData, userPopupType, fromConfirmationDialog, assignQuote, withCheckoutLogic, noInternetCallBack, afterContractSignCallback, executeAfterRegisterIfUserExist);

  if (registerRequestError) {
    if (typeof registerRequestError === 'object') {
      registerRequestError.visualizerOperation = 'userRegister';
    }
    console.error('User register error:', registerRequestError);
    // connectivity errors are filtered out by the reporter itself
    reportNonFatalError('user-register-request-failed', registerRequestError, {assignQuote, userPopupType});
    loaderDisable();
    callErrorPopup({error: getUserRegisterRequestErrorMessage(registerRequestError)});
    if (fabricatorState.isNhance) {
      Analytics.sendParentPostMessage(POST_MESSAGES.userRegisterFalse);
    }
    return false;
  }

  if (!isValidUserRegisterResponse(registerResponse)) {
    const malformedResponseError = new Error("Malformed RegisterClient response");
    malformedResponseError.visualizerOperation = 'userRegister';
    console.error('User register error:', malformedResponseError, registerResponse);
    reportNonFatalError('user-register-malformed-response', malformedResponseError, {
      assignQuote,
      userPopupType,
      responseType: registerResponse ? typeof registerResponse.data : typeof registerResponse,
    });
    loaderDisable();
    callErrorPopup({error: "Registration failed: unexpected server response. Please try again."});
    if (fabricatorState.isNhance) {
      Analytics.sendParentPostMessage(POST_MESSAGES.userRegisterFalse);
    }
    return false;
  }

  if (registerResponse.data.error) {
    callUserRegisterErrorPopup(registerResponse.data, userPopupType, fromConfirmationDialog, assignQuote, withCheckoutLogic, noInternetCallBack, afterContractSignCallback, executeAfterRegisterIfUserExist);
    if (fabricatorState.isNhance) {
      Analytics.sendParentPostMessage(POST_MESSAGES.userRegisterFalse);
    }
    return;
  }

  Analytics.sendClickEvent("user-register-success");
  // Config.setUserInfo(registerResponse.data);
  Analytics.setUserId(registerResponse.data.encodedUserId);
  Analytics.setMixPanelPerson(registerResponse.data.email, registerResponse.data.firstName, registerResponse.data.phoneNumber);
  if (fabricatorState.isNhance) {
    Analytics.sendParentPostMessage(POST_MESSAGES.userRegisterTrue);
  }

  if (assignQuote) {
    return registerResponse.data
  }
  const fabricatorSettings = fabricatorState.settings;

  if (IS_LIXIL_UI) {
    store.dispatch(toggleUserPopup({
      userIsLoggedIn: true,
      encodedUserId: registerResponse.data.encodedUserId,
      isPhoneNumberValidated: !fabricatorSettings.twoFA,
    }));
    return registerResponse.data
  }

  // const docuSignObj = fabricatorSettings.docuSignAuth ? JSON.parse(fabricatorSettings.docuSignAuth) : null;
  store.dispatch(toggleUserPopup({
    userPopupOpened: fabricatorSettings.twoFA,
    schedulerPending: fabricatorSettings.twoFA,
    userIsLoggedIn: true,
    // when user first register we need to check whether the fabricator requires to validate the phone number
    isPhoneNumberValidated: !fabricatorSettings.twoFA, // if 2FA is required we consider user is still NOT logged in
    ...registerResponse.data,
    userInfo: {
      email: registerResponse.data.email
    }
  }));

  if (userPopupType === UserPopupTypes.AIDesign) { // do not show save success notification
    store.dispatch(setLookOverlayOpened(LOOK_OVERLAYS.aiPanel));
    store.dispatch(setLookAiImageOpened(true));
  }

  const submit = window.location.href.includes('shoppingcart');
  const saveQuoteResponse = await saveQuote({
    submit,
    yesNoConsultationRequest,
    quoteRequestType,
    fromCheckOutPage: submit,
    showReceipt: false
  });

  if (fabricatorSettings.twoFA)
    return;

  $(document).trigger(ActionTypes.USER_IS_LOGGED_IN); // click on the active item it the navigation
  if (showSchedule) {
    if (fabricatorSettings.enableCalendarForScheduling) {
      store.dispatch({
        type: types.SHOW_SCHEDULER,
        payload: {show: true}
      })
    } else {
      renderMessagePopup("userPopup.messageBox.appointmentRequested");
    }
  } else {
    // store.dispatch({
    //   type: types.CHANGE_MESSAGE_BOX,
    //   payload: {
    //     visible: true,
    //     error: false,
    //     inline: false,
    //     message: "userPopup.messageBox.designSavedSuccess",
    //     buttons: [{
    //       text: "messageBox.buttonOk",
    //       color: "green",
    //       click: () => {
    //         store.dispatch({
    //           type: types.CHANGE_MESSAGE_BOX,
    //           payload: {
    //             visible: false,
    //           }
    //         });
    //
    //         // console.log('DS - register', fabricatorSettings.showPricing, docuSignObj);
    //         // if (fabricatorSettings.showPricing && docuSignObj && docuSignObj.isEnabled)
    //         //     store.dispatch(showDocuSign(true));
    //
    //         if (checkout && fabricatorSettings.checkout && fabricatorSettings.hasPaymentGateway) {
    //           showCheckoutLayout(fabricatorSettings);
    //         }
    //       }
    //     }]
    //   }
    // });
  }

  // saveQuote returns null when document.kvConfig.canSaveQuote === false
  if (saveQuoteResponse && (saveQuoteResponse.error || saveQuoteResponse.data && saveQuoteResponse.data.error)) {
    loaderDisable();
    renderErrorPopup(saveQuoteResponse.error || saveQuoteResponse.data.error, "", noInternetCallBack);
  }
  return null
};

export const resetUserPassword = () => {
  const state = store.getState();
  const email = state.userState.userInfo.email;
  const language = state.serverState.language;
  loaderEnable();
  JsonApi.resetUserPassword(email, language)
    .then((response) => {
      loaderDisable();
      console.log('resetUserPassword response:', response);
      if (response.data.error) {
        renderErrorPopup(response.data.error);
      } else if (IS_LIXIL_UI) {
        store.dispatch({
          type: types.CHANGE_MESSAGE_BOX,
          payload: {
            visible: true,
            title: "leadCapturePopup.forgot.successPopup.title",
            message: "leadCapturePopup.forgot.successPopup.text",
          }
        })
      } else {
        store.dispatch({
          type: types.CHANGE_MESSAGE_BOX,
          payload: {
            visible: true,
            message: "userPopup.messageBox.passwordHasBeenSent",
            error: false,
            inline: false,
            buttons: [{
              text: "messageBox.buttonOk",
              color: "blue",
              click: () => {
                store.dispatch({
                  type: types.CHANGE_MESSAGE_BOX,
                  payload: {
                    visible: false,
                  }
                });
              }
            }]
          }
        });
      }
    })
    .catch((error) => {
      loaderDisable();
      renderErrorPopup(error);
    });
};

export const getEmployees = (withLoader = true) => {
  if (withLoader) {
    loaderEnable();
  }
  return JsonApi.getEmployees()
    .then((response) => {
      if (withLoader) {
        loaderDisable();
      }
      //console.log('getEmployees response:', response);
      const emplList = response && response.data ? [...response.data] : [];
      store.dispatch(setEmployeesList(emplList));
      return emplList
    })
    .catch((error) => {
      if (withLoader) {
        loaderDisable();
      }
      console.log('getEmployees error:', error);
      return []
      // renderErrorPopup(error);
    });
};

export const getCustomerById = ({customerId,
                                  showContractOnError = false,
                                  noInternetCallBack,
                                  afterContractSignCallback}) => {
  loaderEnable();
  return JsonApi.getCustomerById(customerId)
    .then(response => response.data)
    .catch((error) => {
      loaderDisable();
      renderErrorPopup(error, "", noInternetCallBack, showContractOnError, null, afterContractSignCallback);
    });
};

export const generateTwoFaAuthenticationToken = () => {
  return JsonApi.generateAuthenticationToken()
    .then(response => response.data || response)
    .catch(error => console.log("Server error validateAuthentication "+new Error(error)))
};

export const validateTwoFaAuthentication = (token, authCode, phone) => {
  return JsonApi.validateAuthenticationRequest(token, authCode, phone)
    .then(response => response.data)
    .catch(error => console.log("Server error validateAuthentication "+new Error(error)))
};

export const sendAuthenticationRequest = (token, to, type) => {
  return JsonApi.sendAuthenticationRequest(token, to, type)
    .then(response => response.data)
    .catch(error => console.log("Server error sendAuthenticationRequest "+new Error(error)))
};
